module.exports = __webpack_public_path__ + "img/evenements-2-thumbnail.79a92a32.jpg";